import { render } from "./ConfirmDeleteMenu.vue?vue&type=template&id=397bad37"
import script from "./ConfirmDeleteMenu.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__